// Admin-specific notification types
export const ADMIN_NOTIFICATION_TYPES = {
  NEW_MERCHANT_ONBOARDED: "new_merchant_onboarded",
  NEW_MEMBER_ONBOARDED: "new_member_onboarded",
  MEMBER_SUPPORT_FUNDRAISER: "member_support_fundraiser",
  NEW_FUNDRAISER_REGISTERED: "new_fundraiser_registered",
  WITHDRAWAL_REQUESTED: "withdrawal_requested",
  INVITATION_SENT: "invitation_sent",
  MERCHANT_ONBOARDING_REMINDER_SENT: "merchant_onboarding_reminder_sent",
  MARKETING_ASSETS_UPLOADED_ADMIN: "marketing_assets_uploaded_admin",
  PROMOTION_STATUS_CHANGED: "promotion_status_changed",
  HOMEPAGE_LAYOUT_CHANGED: "homepage_layout_changed",
  FUNDRAISER_STRIPE_ONBOARDED: "fundraiser_stripe_onboarded",
  NEW_SUPPORT_INQUIRY: "new_support_inquiry"
};

// Merchant-specific notification types and messages
export const MERCHANT_NOTIFICATION_TYPES = {
  OFFER_APPROVED: "offer_approved",
  OFFER_REJECTED: "offer_rejected", 
  NEW_OFFER_CREATED: "new_offer_created",
  NEW_REDEMPTION: "new_redemption",
  PAYMENT_RECEIVED: "payment_received",
  LOW_STOCK: "low_stock",
  CAMPAIGN_END: "campaign_end",
  SYSTEM_MAINTENANCE: "system_maintenance",
  NEW_CUSTOMER: "new_customer",
  SECONDARY_MEMBER_INVITED: "secondary_member_invited",
  SECONDARY_MEMBER_ACCEPTED: "secondary_member_accepted",
  SECONDARY_MEMBER_REMOVED: "secondary_member_removed"
};

// Fundraiser-specific notification types and messages
export const FUNDRAISER_NOTIFICATION_TYPES = {
  REFERRAL_APPROVED: "referral_approved",
  REFERRAL_REJECTED: "referral_rejected",
  NEW_REFERRAL: "new_referral",
  PAYMENT_RECEIVED: "payment_received",
  FUNDS_DEPOSITED: "funds_deposited",
  WITHDRAWAL_APPROVED: "withdrawal_approved",
  WITHDRAWAL_REJECTED: "withdrawal_rejected",
  CAMPAIGN_END: "campaign_end",
  SYSTEM_MAINTENANCE: "system_maintenance",
  NEW_DONOR: "new_donor",
  NEW_MERCHANT_REFERRED: "new_merchant_referred",
  MARKETING_ASSETS_UPLOADED: "marketing_assets_uploaded",
  WITHDRAWAL_INITIATED: "withdrawal_initiated"
};

export const MERCHANT_NOTIFICATION_MESSAGES = {
  [MERCHANT_NOTIFICATION_TYPES.OFFER_APPROVED]: "Your offer has been approved and is now live on the platform",
  [MERCHANT_NOTIFICATION_TYPES.OFFER_REJECTED]: "Your offer has been rejected. Please review the feedback and resubmit",
  [MERCHANT_NOTIFICATION_TYPES.NEW_OFFER_CREATED]: "A new offer has been created and is pending approval",
  [MERCHANT_NOTIFICATION_TYPES.NEW_REDEMPTION]: "A customer has redeemed your offer. Check your dashboard for details",
  [MERCHANT_NOTIFICATION_TYPES.PAYMENT_RECEIVED]: "Payment of ${amount} has been received for offer redemption",
  [MERCHANT_NOTIFICATION_TYPES.LOW_STOCK]: "Your offer is running low on available codes. Consider adding more",
  [MERCHANT_NOTIFICATION_TYPES.CAMPAIGN_END]: "Your campaign ends in 24 hours. Consider extending or creating a new one",
  [MERCHANT_NOTIFICATION_TYPES.SYSTEM_MAINTENANCE]: "Scheduled maintenance will occur in 2 hours. Some features may be temporarily unavailable",
  [MERCHANT_NOTIFICATION_TYPES.NEW_CUSTOMER]: "A new customer has registered through your offer",
  [MERCHANT_NOTIFICATION_TYPES.SECONDARY_MEMBER_INVITED]: "An invitation has been sent to secondary member",
  [MERCHANT_NOTIFICATION_TYPES.SECONDARY_MEMBER_ACCEPTED]: "Secondary member has accepted your invitation",
  [MERCHANT_NOTIFICATION_TYPES.SECONDARY_MEMBER_REMOVED]: "Secondary member has been removed from your team"
};

export const FUNDRAISER_NOTIFICATION_MESSAGES = {
  [FUNDRAISER_NOTIFICATION_TYPES.REFERRAL_APPROVED]: "Your referral has been approved and is now active",
  [FUNDRAISER_NOTIFICATION_TYPES.REFERRAL_REJECTED]: "Your referral has been rejected. Please review the feedback and resubmit",
  [FUNDRAISER_NOTIFICATION_TYPES.NEW_REFERRAL]: "A new referral has been made through your campaign",
  [FUNDRAISER_NOTIFICATION_TYPES.PAYMENT_RECEIVED]: "Payment of ${amount} has been received for your referral",
  [FUNDRAISER_NOTIFICATION_TYPES.FUNDS_DEPOSITED]: "Funds of ${amount} have been deposited to your account",
  [FUNDRAISER_NOTIFICATION_TYPES.WITHDRAWAL_APPROVED]: "Your withdrawal request of ${amount} has been approved",
  [FUNDRAISER_NOTIFICATION_TYPES.WITHDRAWAL_REJECTED]: "Your withdrawal request has been rejected. Please contact support",
  [FUNDRAISER_NOTIFICATION_TYPES.CAMPAIGN_END]: "Your fundraising campaign ends in 24 hours. Consider extending or creating a new one",
  [FUNDRAISER_NOTIFICATION_TYPES.SYSTEM_MAINTENANCE]: "Scheduled maintenance will occur in 2 hours. Some features may be temporarily unavailable",
  [FUNDRAISER_NOTIFICATION_TYPES.NEW_DONOR]: "A new donor has contributed through your campaign"
};

export const getMerchantNotificationIcon = (type) => {
  switch (type) {
    case MERCHANT_NOTIFICATION_TYPES.OFFER_APPROVED:
    case MERCHANT_NOTIFICATION_TYPES.PAYMENT_RECEIVED:
      return "approved";
    case MERCHANT_NOTIFICATION_TYPES.OFFER_REJECTED:
      return "rejected";
    case MERCHANT_NOTIFICATION_TYPES.NEW_OFFER_CREATED:
      return "new_offer";
    case MERCHANT_NOTIFICATION_TYPES.NEW_REDEMPTION:
      return "redemption";
    case MERCHANT_NOTIFICATION_TYPES.LOW_STOCK:
      return "warning";
    case MERCHANT_NOTIFICATION_TYPES.CAMPAIGN_END:
      return "time";
    case MERCHANT_NOTIFICATION_TYPES.SYSTEM_MAINTENANCE:
      return "maintenance";
    case MERCHANT_NOTIFICATION_TYPES.NEW_CUSTOMER:
      return "customer";
    default:
      return "default";
  }
};

export const getFundraiserNotificationIcon = (type) => {
  switch (type) {
    case FUNDRAISER_NOTIFICATION_TYPES.REFERRAL_APPROVED:
    case FUNDRAISER_NOTIFICATION_TYPES.PAYMENT_RECEIVED:
    case FUNDRAISER_NOTIFICATION_TYPES.FUNDS_DEPOSITED:
    case FUNDRAISER_NOTIFICATION_TYPES.WITHDRAWAL_APPROVED:
    case FUNDRAISER_NOTIFICATION_TYPES.MARKETING_ASSETS_UPLOADED:
    case FUNDRAISER_NOTIFICATION_TYPES.WITHDRAWAL_INITIATED:
      return "approved";
    case FUNDRAISER_NOTIFICATION_TYPES.REFERRAL_REJECTED:
    case FUNDRAISER_NOTIFICATION_TYPES.WITHDRAWAL_REJECTED:
      return "rejected";
    case FUNDRAISER_NOTIFICATION_TYPES.NEW_REFERRAL:
    case FUNDRAISER_NOTIFICATION_TYPES.NEW_DONOR:
    case FUNDRAISER_NOTIFICATION_TYPES.NEW_MERCHANT_REFERRED:
      return "referral";
    case FUNDRAISER_NOTIFICATION_TYPES.CAMPAIGN_END:
      return "time";
    case FUNDRAISER_NOTIFICATION_TYPES.SYSTEM_MAINTENANCE:
      return "maintenance";
    default:
      return "default";
  }
};

export const getMerchantNotificationColor = (type) => {
  switch (type) {
    case MERCHANT_NOTIFICATION_TYPES.OFFER_APPROVED:
    case MERCHANT_NOTIFICATION_TYPES.PAYMENT_RECEIVED:
      return "green";
    case MERCHANT_NOTIFICATION_TYPES.OFFER_REJECTED:
      return "red";
    case MERCHANT_NOTIFICATION_TYPES.NEW_OFFER_CREATED:
      return "blue";
    case MERCHANT_NOTIFICATION_TYPES.NEW_REDEMPTION:
      return "blue";
    case MERCHANT_NOTIFICATION_TYPES.LOW_STOCK:
    case MERCHANT_NOTIFICATION_TYPES.CAMPAIGN_END:
      return "yellow";
    case MERCHANT_NOTIFICATION_TYPES.SYSTEM_MAINTENANCE:
      return "orange";
    case MERCHANT_NOTIFICATION_TYPES.NEW_CUSTOMER:
      return "purple";
    default:
      return "gray";
  }
};

export const getFundraiserNotificationColor = (type) => {
  switch (type) {
    case FUNDRAISER_NOTIFICATION_TYPES.REFERRAL_APPROVED:
    case FUNDRAISER_NOTIFICATION_TYPES.PAYMENT_RECEIVED:
    case FUNDRAISER_NOTIFICATION_TYPES.FUNDS_DEPOSITED:
    case FUNDRAISER_NOTIFICATION_TYPES.WITHDRAWAL_APPROVED:
    case FUNDRAISER_NOTIFICATION_TYPES.MARKETING_ASSETS_UPLOADED:
    case FUNDRAISER_NOTIFICATION_TYPES.WITHDRAWAL_INITIATED:
      return "green";
    case FUNDRAISER_NOTIFICATION_TYPES.REFERRAL_REJECTED:
    case FUNDRAISER_NOTIFICATION_TYPES.WITHDRAWAL_REJECTED:
      return "red";
    case FUNDRAISER_NOTIFICATION_TYPES.NEW_REFERRAL:
    case FUNDRAISER_NOTIFICATION_TYPES.NEW_DONOR:
    case FUNDRAISER_NOTIFICATION_TYPES.NEW_MERCHANT_REFERRED:
      return "blue";
    case FUNDRAISER_NOTIFICATION_TYPES.CAMPAIGN_END:
      return "yellow";
    case FUNDRAISER_NOTIFICATION_TYPES.SYSTEM_MAINTENANCE:
      return "orange";
    default:
      return "gray";
  }
};

// Helper function to format notification message with dynamic values
export const formatNotificationMessage = (type, data = {}, role = "merchant") => {
  let message = "";
  
  if (role === "merchant") {
    message = MERCHANT_NOTIFICATION_MESSAGES[type] || "You have a new notification";
  } else if (role === "fundraiser") {
    message = FUNDRAISER_NOTIFICATION_MESSAGES[type] || "You have a new notification";
  } else {
    message = "You have a new notification";
  }
  
  // Replace placeholders with actual data
  if (data.amount) {
    message = message.replace("${amount}", data.amount);
  }
  if (data.customerName) {
    message = message.replace("${customerName}", data.customerName);
  }
  if (data.offerName) {
    message = message.replace("${offerName}", data.offerName);
  }
  if (data.donorName) {
    message = message.replace("${donorName}", data.donorName);
  }
  
  return message;
}; 